// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1054":"c5376738","6751":"100065f3","9460":"c5376738"}[chunkId] + ".chunk.css";
};